// DELETE_SCOPE: Enum para los tipos de alcance del borrado
export const DELETE_SCOPE = {
  TODAY: "today",      // Borrar solo del día actual (selectedDayKey)
  ALL: "all"           // Borrar de todos los días (implementación en siguiente prompt)
};
